import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromProfessorReducer from '../reducers/professor.reducer';

export const selectState = createFeatureSelector<fromProfessorReducer.State>(
  fromProfessorReducer.featureKey
);

export const getProfessors = createSelector(selectState, (state) => state.professor);
export const getProfessorSubjects = createSelector(selectState, (state) => state.subjects);
export const getProfSubjectStudents = createSelector(selectState, (state) => state.subjects.students);
export const getSubjectWorkItems = createSelector(selectState, (state) => state.subjects.workItems.data);
export const selectWorkItemStudentsGrade = createSelector(selectState, (state) => state.grades);
export const selectGradeDetails = createSelector(selectState, (state) => state.gradeDetails.data);

